import React from "react"
import { graphql } from "gatsby"
import { MultiContentBlock } from "./MultiContentBlock"
import "./multi-content-blocks.module.scss"
import {
  SingleContentBlock,
  StrapiMultiContentBlockLayoutOverrideOptions,
} from "./multi-content-block"

interface MultiContentBlocksProps {
  blocks: SingleContentBlock[]
  multi_block_heading: string | null
  multi_block_sub_heading: string | null
  layout_override_options: StrapiMultiContentBlockLayoutOverrideOptions
  mcb_alternate_background_color: boolean
}

export const MultiContentBlocks = ({
  multi_block_heading,
  multi_block_sub_heading,
  blocks,
  layout_override_options = "default",
  mcb_alternate_background_color,
}: MultiContentBlocksProps) => {
  const layoutOptions = {
    default: "multi-content-block-wrapper-3-blocks",
    "two-column": "multi-content-block-wrapper-2-blocks",
    "four-column": "multi-content-block-wrapper-4-blocks",
    "one-third-two-thirds-grid": "multi-content-block-wrapper-5-blocks",
    "one-eighth-seven-eighths-grid": "multi-content-block-wrapper-7-blocks",
  };
  const layout = layoutOptions[layout_override_options] || "multi-content-block-wrapper-3-blocks";
  const alternateBackground = mcb_alternate_background_color
    ? " alternate-background-color"
    : ""

  const blockCount = blocks?.length || 0

  return (
    <section
      className={`multi-content-blocks u-content-block-padding ${alternateBackground}`}
    >
      <div
        className={`fr-container ${
          blockCount >= 3 ? "fr-container--large" : ""
        }`}
      >
        {multi_block_heading && (
          <div className="text-content-block__title">
            <h2>{multi_block_heading}</h2>
            {multi_block_sub_heading && <h3>{multi_block_sub_heading}</h3>}
          </div>
        )}
        <div className={layout}>
          {blocks?.map(({ id, ...blockProps }) => {
            if (
              !blockProps ||
              (blockProps && Object.keys(blockProps).length === 0)
            )
              return
            return <MultiContentBlock key={id} {...blockProps} />
          })}
        </div>
      </div>
    </section>
  )
}

export const query = graphql`
  fragment StrapiMultiContentBlocksFragment on STRAPI__COMPONENT_CONTENT_BLOCK_MULTI_CONTENT_BLOCK {
    id
    strapi_component
    eyebrow_text
    multi_block_heading: heading
    multi_block_sub_heading: sub_heading
    mcb_alternate_background_color
    layout_override_options
    blocks {
      ...StrapiContentBlockFragment
    }
  }
`
